export enum Position {
  top = 1,
  right = 2,
  footer = 3,
  left = 4,
}
